import React from "react";
import { Card, Icon, Row, Text } from "@amzn/meridian";
import chevronRightSmallTokens from "@amzn/meridian-tokens/base/icon/chevron-right-small";
import { Question } from "src/data/types";
type QuestionDisplayCardProps = {
  question: Question;
  questionOrder: number;
};
const QuestionDisplayCard = ({
  question,
  questionOrder,
}: QuestionDisplayCardProps) => {
  return (
    <Card spacingInset="none">
      <Row alignmentHorizontal="justify" spacingInset="300 400">
        <Text>{`${questionOrder}. ${question.questionText}`}</Text>
        <Icon tokens={chevronRightSmallTokens} color="primary" />
      </Row>
    </Card>
  );
};

export default QuestionDisplayCard;
